<template>
  <div class="page page-create-serve">
    <h3>Новое техническое обслуживание</h3>
    <div class="form-group">
      <label for="exampleInputEmail1">Дата/время обслуживания</label>
      <input
        type="datetime-local"
        class="form-control"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        placeholder="Введите дату/время обслуживания"
        :max="now()"
        v-model="service.datetime"
      />
    </div>
    <div class="form-group">
      <label for="exampleInputEmail2">Фактические показания одометра</label>
      <input
        type="number"
        class="form-control"
        id="exampleInputEmail2"
        aria-describedby="emailHelp"
        placeholder="Введите значение одометра"
        v-model="service.total_odometer_stamp"
      />
    </div>
    <ul class="list-group">
      <li class="list-group-item" v-for="work in works" :key="work.id">
        <input type="checkbox" class="form-check-input" :id="`checkbox${work.id}`" v-model="work.selected" />
        <label class="form-check-label" :for="`checkbox${work.id}`">{{ work.name }}</label>
      </li>
    </ul>
    <br />
    <div class="form-group">
      <label for="exampleFormControlTextarea1">Прочие работы</label>
      <textarea class="form-control" id="exampleFormControlTextarea1" v-model="service.notes" rows="6"></textarea>
    </div>
    <button class="btn btn-primary" @click="createServe()">Сохранить</button>
    <router-link class="btn btn-primary" style="margin-right: 10px;"  :to="`/serve/${car.id}`">Назад</router-link>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import serveApi from '@/api/serve'
import { djsMixin } from '@/components/mixins/djsMixin'
import Swal from 'sweetalert2'
import usersAPI from '@/api/users'

export default {
  name: 'CreateServe',
  props: ['carId'],
  mixins: [djsMixin],
  mounted () {
    this.loadItem({ id: this.carId })
    this.loadItems({ sort: 'sort' })
  },
  computed: {
    ...mapState('taxi/cars', {
      car (state) {
        return state.items.find(el => el.id == this.carId)
      },
      isLoading: state => state.isLoading
    }),
    ...mapState('taxi/serviceWorks', {
      worksState: state => state.items.filter(e => !e.archived_at),
      isLoading: state => state.isLoading
    }),
    works: {
      get () {
        if (!this.worksCopy) {
          return JSON.parse(JSON.stringify(this.worksState))
        }
        return this.worksCopy
      }
    }
  },
  data () {
    return {
      worksCopy: null,
      service: {
        car_id: this.carId,
        total_odometer_stamp: null,
        author_id: null,
        datetime: this.now(),
        notes: null
      },
      isCreating: false
    }
  },
  methods: {
    ...mapActions('taxi/cars', [
      'loadItem'
    ]),
    ...mapActions('taxi/serviceWorks', [
      'loadItems'
    ]),
    createServe () {
      if (this.isCreating) return
      usersAPI
        .getCurrentUser()
        .then(user => {
          this.isCreating = true
          serveApi.createItem({
            ...this.service,
            datetime: this.toUTCtranslate(this.service.datetime),
            car_id: this.carId,
            author_id: user.id,
            worksRelatedIds: this.works.filter(x => x.selected).map(x => x.id)
          })
            .then(work => {
              this.isCreating = false
              this.$router.push(`/serve/${this.carId}`)
            })
            .catch(text => {
              this.isCreating = false
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: text.message
              })
            })
        })
        .catch(text => {
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
<style scoped>
  .page-create-serve {
    width: 98%;
    padding-bottom: 4rem;
  }
  .page-create-serve .btn-primary {
    width: 8rem;
    float: right !important;
  }
  .page-create-serve .card {
    margin: 0.3rem 0;
  }
  .page-create-serve .card .card-body {
    text-align: start;
  }
  .list-group-item {
    padding: 1rem 2.5rem;
  }
</style>
